import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrRoomOccupancy.ts
var t = () => e("roomOccupancy");
//#endregion
export { t as useTrRoomOccupancy };
